<template>
  <div v-show="visible" class="loading-wrap">
    <div class="loading-box">
      <i class="el-icon-loading"></i>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
};
</script>
<style lang="less" scoped>
@keyframes turn {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(90deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(270deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
.loading-box i {
  font-size: 48px;
  color: #0095f9;
  transition: color 0.1s linear;
  }
.loading-wrap {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 255, .4);
}
.loading-box {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 50px;
  width: 50px;
  transform: translate(-50%, -50%);
  span {
    width: 100%;
    height: 100%;
    animation: turn 1s linear infinite;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/loading/loading.vue